import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { HORM_F } from "../../../../constants";


export default function HormFemaleAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={HORM_F}
        title="HORMONES & FERTILITY FEMALE"
        subtitle="Designed to uncover hormonal imbalances linked to cycle irregularities, fertility concerns, and menopausal symptoms"
        markersTitle=" 149,- incl. VAT"
        markers="Estradiol (E2), Testosterone, Luteinizing Hormone (LH), Follicle-Stimulating Hormone (FSH), Progesterone (P4), Prolactin, Bioavailable Testosterone, SHBG, DHEA-S, Testosterone/E2 ratio"

    />

)
}